import React from "react";
import { Grid, Typography, Stack, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import CarouselComp from "./CarouselComp";
import useMediaQuery from "@mui/material/useMediaQuery";
import ViewRecurringDetails from "../../../shared/Modal/ViewRecurringDetailsModal";
import NumberFormat from "react-number-format";

const useStyles = makeStyles({
  carouselContainer: {
    margin: "1.75rem 0 3.125rem 0",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "space-between",
    justifyContent: "center",
  },
});

export default function RecurringCatalog(props: any) {
  const classes = useStyles();
  let someData = [];
  if (props.methods) {
    for (let i = 0; i < props.methods?.length; i++) {
      someData.push(props.methods[i]);
    }
  }
  let popularBundles = JSON.parse(JSON.stringify(someData));
  return (
    <Grid container>
      <CarouselWrapperRect classes={classes} data={popularBundles} openAutopayDetails={props.openAutopayDetails} setOpenAutopayDetails={props.setOpenAutopayDetails} />
    </Grid>
  );
}

const CarouselWrapperRect = (props: any) => {
  const classes = useStyles();
  let newArray = [];
  let newData = [...props.data];
  while (newData.length > 0) newArray.push(newData.splice(0, 1));
  return (
    <Grid item container>
      <Grid item container className={classes.carouselContainer}>
        <CarouselComp>
          {newArray.map((each: any, index) => (
            <CarouselSlideRect newData={each} key={index} openAutopayDetails={props.openAutopayDetails} setOpenAutopayDetails={props.setOpenAutopayDetails} />
          ))}
        </CarouselComp>
      </Grid>
    </Grid>
  );
};
const CarouselSlideRect = (props: any) => {
  const matchesMobile = useMediaQuery("(max-width:600px)");
  const [openViewModal, setOpenViewModal] = React.useState(false);
  const openViewModalHandler = () => {
    setOpenViewModal(true);
  };
  const closeViewModalHandler = () => {
    props.setOpenAutopayDetails(false);
    setOpenViewModal(false);
  };

  React.useEffect(() => {
    if (props.openAutopayDetails) {
      setOpenViewModal(props.openAutopayDetails);
    }

    return;
  }, [props.openAutopayDetails]);

  const classes = useStyles();
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={matchesMobile ? 2 : 1}
      style={{
        width: "270px",
        // marginLeft: "-15px",
        //backgroundColor:'yellow'
      }}
    >
      {props?.newData &&
        props?.newData.map((each: any, index: number) => {
          const firstPayFromMethod = each.ScheduledAutoPayDetails?.[0].FromPayMethod;
          const payMethodText = firstPayFromMethod.CardType ? `Card #${firstPayFromMethod.AccountLastFour}` : `Bank #${firstPayFromMethod.AccountLastFour}`;
          return (
            <div key={index}>
              <div>
                <Typography
                  style={{
                    color: "#14142B",
                    fontFamily: '"Work Sans",Sans-serif',
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "18px",
                    textAlign: "left",
                    marginLeft: "-30px",
                    lineHeight: "22px",
                    marginBottom: "10px",
                  }}
                >
                  {each?.Type === "Fixed" ? (
                    <NumberFormat
                      thousandsGroupStyle="thousand"
                      value={(each?.FixedAmount || 0) / 100}
                      prefix="$"
                      decimalSeparator="."
                      displayType="text"
                      type="text"
                      thousandSeparator={true}
                      allowNegative={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  ) : (
                    "My Full Balance"
                  )}
                </Typography>
              </div>
              <Stack direction="row" justifyContent="space-between" alignItems="space-between" spacing={2}>
                <div>
                  <Typography
                    style={{
                      color: "#14142B",
                      fontFamily: '"Work Sans",Sans-serif',
                      fontStyle: "normal",
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginLeft: "-30px",
                      lineHeight: "22px",
                    }}
                  >
                    Next payment
                  </Typography>
                </div>
                <div>
                  <Typography
                    style={{
                      color: "#D3D3D3",
                      fontFamily: '"Work Sans",Sans-serif',
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "14px",
                      marginRight: "-30px",
                      paddingTop: "2px",
                      lineHeight: "22px",
                    }}
                  >
                    {each?.Frequency === "M" ? "Month.." : each?.Frequency === "Q" ? "Quart.." : each?.Frequency === "S" ? "Semi.." : "Annua.."}
                  </Typography>
                </div>
              </Stack>
              <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
                <Typography
                  style={{
                    color: "#14142B",
                    fontFamily: '"Work Sans",Sans-serif',
                    fontStyle: "normal",
                    fontSize: "18px",
                    marginLeft: "-30px",
                    //paddingBottom:'10px'
                  }}
                >
                  {moment(each?.NextScheduledPaymentDate).format("MM/DD/YY")}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" alignItems="space-between" spacing={2}>
                <div className={classes.container}>
                  <Typography
                    style={{
                      color: "#14142B",
                      fontFamily: '"Work Sans",Sans-serif',
                      fontStyle: "normal",
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginLeft: "-30px",
                      paddingTop: "12px",
                    }}
                  >
                    {payMethodText}
                  </Typography>
                </div>
                <div>
                  <Typography
                    style={{
                      color: "#14142B",
                      fontFamily: '"Work Sans",Sans-serif',
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "18px",
                      marginRight: "-30px",
                      paddingTop: "12px",
                    }}
                  >
                    {each?.FromPayMethod?.AccountLastFour}
                  </Typography>
                </div>
              </Stack>

              <div
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginLeft: "0px",
                }}
              >
                <Button id="viewRecurringPaymentBtn" variant="contained" onClick={openViewModalHandler}>
                  View
                </Button>
              </div>
              {openViewModal ? <ViewRecurringDetails openModal={openViewModal} handleCloseModal={closeViewModalHandler} selectedAutoPay={props.openAutopayDetails ? props.newData[0] : each} openAutopayDetails={props.openAutopayDetails}/> : <></>}
            </div>
          );
        })}
    </Stack>
  );
};
